import {useFilterModal} from '@/components/basic/filter-modal';
import {useTranslation} from 'react-i18next';
import React, {FC, useEffect, useMemo} from 'react';
import FilterIcon from '@/components/svgs/basic/filer';
import {DownIcon} from '@/common-pages/casino/svg.variable';

interface RiskFilterProps {
  onFilterChange: (filter: string) => void;
}

const RiskFilter: FC<RiskFilterProps> = ({onFilterChange}) => {
  const {t} = useTranslation();

  const filterOptions = useMemo(() => {
    return [
      {
        title: t('label.all'),
        value: 'all',
      },
      {
        title: t('label.processing'),
        value: 'processing',
      },
      {
        title: t('label.unissued'),
        value: 'unissued',
      },
      // {
      //   title: t('label.normal'),
      //   value: 'normal',
      // },
    ];
  }, [t]);
  const {show, currentValue, renderModal} = useFilterModal(
    t('filter.risk'),
    filterOptions,
  );
  useEffect(() => {
    onFilterChange(currentValue || 'all');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);
  return (
    <div
      className="h-12 flex flex-row items-center justify-between bg-white rounded-lg px-3"
      onClick={() => {
        show();
      }}>
      <FilterIcon className="size-4" />
      <div className="flex flex-row gap-3">
        <span className="text-t1 font-bold text-sm uppercase">
          {currentValue}
        </span>
        <DownIcon className="size-3.5" />
      </div>
      {renderModal}
    </div>
  );
};

export default RiskFilter;
